var FcTextAreaInputModule = /** @class */ (function () {
    function FcTextAreaInputModule() {
    }
    return FcTextAreaInputModule;
}());
export { FcTextAreaInputModule };
